<script setup>
import WebsiteSeo from './Components/WebsiteSeo.vue';
import WebsiteFooter from './Components/WebsiteFooter.vue';
import WebsiteHeader from './Components/WebsiteHeader.vue';
import AboutMe from './Components/AboutMe.vue';
import ScheduleMe from './Components/ScheduleMe.vue';
import MainBanner from './Components/MainBanner.vue';
import BlogPostSection from './Components/BlogPostSection.vue';

defineProps({
    seo: Object,
    web_site: Object,
    blog_posts: Array,
    blog_count: Number,
    preview: Boolean,
    selfSchedulingLink: String
});


</script>


<template>
    <WebsiteSeo :seo="seo" />
    
    <WebsiteHeader :web_site="web_site" :hasBlog="blog_posts.length > 0" :preview="preview" :self-scheduling-link="selfSchedulingLink" />
    
    <MainBanner :web_site="web_site" :self-scheduling-link="selfSchedulingLink" />
    <AboutMe :web_site="web_site" />
    
    <ScheduleMe :web_site="web_site" :selfSchedulingLink="selfSchedulingLink" />

    <BlogPostSection v-if="blog_count > 0" :web_site="web_site" :blog_posts="blog_posts" :preview="preview" />
    
    <WebsiteFooter :web_site="web_site" :self-scheduling-link="selfSchedulingLink" />
    
</template>
